import React, { useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { stateFromHTML } from 'draft-js-import-html';
import { Editor, EditorState, RichUtils, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import PropTypes from 'prop-types';
import { getClassName } from '../../utils/InputValidation';
import Label from '../Fields/Label/Label';

const editorStyles = {
  inlineStyle: {
    bold: 'BOLD',
    italic: 'ITALIC',
  },
  blickType: {
    ul: 'unordered-list-item',
    ol: 'ordered-list-item',
  },
};

const TextEditor = (props) => {
  useEffect(() => {
    const contentState = stateFromHTML(props.input.value);
    setEditorState(EditorState.createWithContent(contentState));
  }, []);
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const { optional, input, label, meta: { touched, invalid, visited, }, } = props;
  const classes = useStyles();

  // trigered by key shorcuts like comand + b for Bold text or cmd +z for undo
  const handleKeyCommand = (command, editor) => {
    const newState = RichUtils.handleKeyCommand(editor, command);
    if (newState) {
      handleEditorChange(newState);
      return 'handled';
    }
    return 'not-handled';
  };

  const handleInlineStyle = (type) => {
    handleEditorChange(RichUtils.toggleInlineStyle(editorState, type));
  };
  const handleBlockType = (type) => {
    handleEditorChange(RichUtils.toggleBlockType(editorState, type));
  };

  const handleEditorChange = (newEditorObj) => {
    setEditorState(newEditorObj);
    const rawContentState = convertToRaw(newEditorObj.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState);
    props.input.onChange(htmlContent);
  };

  return (
    <div className="input-wrapper input-wrapper--textarea">
      { label && <Label optional={optional} name={props.input.name} label={label} /> }
      <div className={classes.tollsConainer}>
        <span
          tabIndex={0}
          role="button"
          className="material-icons"
          onClick={() => handleInlineStyle(editorStyles.inlineStyle.bold)}
        >
          format_bold
        </span>
        <span
          tabIndex={0}
          role="button"
          className="material-icons"
          onClick={() => handleInlineStyle(editorStyles.inlineStyle.italic)}
        >
          format_italic
        </span>
        <span
          tabIndex={0}
          role="button"
          className="material-icons"
          onClick={() => handleBlockType(editorStyles.blickType.ul)}
        >
          list
        </span>
        <span
          tabIndex={0}
          role="button"
          className="material-icons"
          onClick={() => handleBlockType(editorStyles.blickType.ol)}
        >
          format_list_numbered_rtl
        </span>
      </div>
      <div className={`${getClassName(touched, invalid, visited)} ${classes.editorContainer}`} >
        <Editor
          {...input}
          editorState={editorState}
          onChange={handleEditorChange}
          handleKeyCommand={handleKeyCommand}
        />
      </div>
      <style>{`
        .public-DraftEditor-content{
          min-height: 100px;
        }
      `}</style>
    </div>
  );
};

TextEditor.propTypes = {
  input: PropTypes.object.isRequired,
  optional: PropTypes.bool,
  label: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
};

TextEditor.defaultProps = {
  optional: false,
};


const useStyles = createUseStyles({
  tollsConainer: {
    display: 'flex',
    '& span': {
      fontSize: '22px',
    },
  },
  editorContainer: {
    '& li': {
      marginLeft: '16px !important',
    },
  },
});

export default TextEditor;
